import { AlarmState, alarmStateSchema } from '@sophocles/entities/AlarmState/alarmStateRecord';
import { mapListToRecords, normalizeList, websocketsHandlerFactory } from '@sophocles/entities/entityUtils';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';

/* RECEIVE ACTIONS */
export const RECEIVE_ALARM_STATES = 'RECEIVE_ALARM_STATES';
export function receiveAlarmStates(json) {
  return {
    type: RECEIVE_ALARM_STATES,
    alarmStates: mapListToRecords(json, AlarmState),
  };
}

export const RECEIVE_AND_CLEAR_SITE_ALARM_STATES = 'RECEIVE_AND_CLEAR_SITE_ALARM_STATES';
export function receiveAndClearSiteAlarmStates(site, json) {
  return {
    type: RECEIVE_AND_CLEAR_SITE_ALARM_STATES,
    site,
    alarmStates: mapListToRecords(json, AlarmState),
  };
}

/* REQUEST ACTIONS */
// unused
export const REQUEST_ALARM_STATE = 'REQUEST_ALARM_STATE';
function requestAlarmState(alarmState_id) {
  return {
    type: REQUEST_ALARM_STATE,
    alarmState_id,
  };
}

export const REQUEST_SITE_GROUP_ALARM_STATES = 'REQUEST_SITE_GROUP_ALARM_STATES';

export const REQUEST_SITE_ALARM_STATES = 'REQUEST_SITE_ALARM_STATES';
function requestSiteAlarmStates(site_id) {
  return {
    type: REQUEST_SITE_ALARM_STATES,
    site_id: site_id,
  };
}

/* FETCH ACTIONS */
export function fetchAlarmStatesForSite(site_id) {
  return dispatch => {
    dispatch(requestSiteAlarmStates(site_id));
    return apiClient
      .get(`/sites/${site_id}/alarmstates/?limit=500`)
      .then(response => normalizeList(response.data.results, 'alarmStates', alarmStateSchema))
      .then(json => dispatch(receiveAndClearSiteAlarmStates(site_id, json.entities.alarmStates)));
  };
}

/* Delete Actions */
export const DELETE_ALARM_STATE = 'DELETE_ALARM_STATE';
function sayDeleteAlarmState(alarmState) {
  return {
    type: DELETE_ALARM_STATE,
    alarmState,
  };
}

export function deleteAlarmState(alarmState_id) {
  return dispatch =>
    apiClient
      .delete(`/alarmstates/${alarmState_id}/`)
      .then(checkHttpStatus)
      .then(r => dispatch(sayDeleteAlarmState(alarmState_id)))
      .catch(error => dispatch(genericErrorAction(error, DELETE_ALARM_STATE)));
}

const receiver = (dispatch, json) => dispatch(receiveAlarmStates(json.entities.alarmStates));

export const handleAlarmStateSocketActions = websocketsHandlerFactory(receiver, sayDeleteAlarmState, alarmStateSchema);
